window.ForecastShopifyTime = window.ForecastShopifyTime || (function () {
  let syncPromise = null;
  let serverNowMs = null;
  let startedAt = 0;
  const listeners = new Set();

  function cartJsUrl() {
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return `${root.replace(/\/$/, '')}/cart.js`;
  }

  function parseUnixMs(value) {
    const seconds = Number(value);
    if (!value || Number.isNaN(seconds) || seconds <= 0) {
      return 0;
    }

    return seconds * 1000;
  }

  function applyServerNow(serverMs) {
    serverNowMs = serverMs;
    startedAt = performance.now();
    listeners.forEach((listener) => listener());
  }

  function initFromLiquid(unixSeconds) {
    const serverMs = parseUnixMs(unixSeconds);
    if (serverMs && serverNowMs === null) {
      applyServerNow(serverMs);
    }
  }

  function now() {
    if (serverNowMs === null) {
      return Date.now();
    }

    return serverNowMs + (performance.now() - startedAt);
  }

  function sync() {
    if (!syncPromise) {
      syncPromise = fetch(cartJsUrl(), {
        cache: 'no-store',
        credentials: 'same-origin',
      })
        .then((response) => {
          const dateHeader = response.headers.get('Date');
          if (!dateHeader) {
            return now();
          }

          const serverMs = Date.parse(dateHeader);
          if (!Number.isNaN(serverMs)) {
            applyServerNow(serverMs);
          }

          return now();
        })
        .catch(() => now());
    }

    return syncPromise;
  }

  function subscribe(listener) {
    listeners.add(listener);
    return function unsubscribe() {
      listeners.delete(listener);
    };
  }

  return {
    parseUnixMs,
    initFromLiquid,
    now,
    sync,
    subscribe,
  };
})();
